import { SessionTemplatesRepository, type SessionTemplate } from "../../session_templates";

/** The templates a session's notes are written against. */

export async function listSessionTemplates(): Promise<SessionTemplate[]> {
    return new SessionTemplatesRepository().listTemplates();
}

export async function getSessionTemplate(templateId: string): Promise<SessionTemplate> {
    return new SessionTemplatesRepository().getTemplate(templateId);
}
